/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInLimitSnapshotAction } from './linkedInLimitSnapshotAction';
import type { LinkedInLimitSnapshotStatus } from './linkedInLimitSnapshotStatus';

/**
 * Soft daily-limit readout after a LinkedIn execute.
 *
 * ``status`` mirrors the Connected Accounts usage chips: ``warning`` at
 * >=60% of the daily cap, ``critical`` at >=80%. Advisory only — sends
 * are never blocked by these numbers.
 */
export interface LinkedInLimitSnapshot {
  action: LinkedInLimitSnapshotAction;
  /** @minimum 0 */
  used_today: number;
  /** @minimum 0 */
  daily_limit: number;
  status: LinkedInLimitSnapshotStatus;
}
